// extracted by mini-css-extract-plugin
module.exports = {"BubbleContentsNext":"payment_BubbleContentsNext__28u1D","buttonSeparator":"payment_buttonSeparator__hH2Vn"};